import { render } from "./AppLogo.vue?vue&type=template&id=2842ada6&scoped=true"
import script from "./AppLogo.vue?vue&type=script&lang=js"
export * from "./AppLogo.vue?vue&type=script&lang=js"

import "./AppLogo.vue?vue&type=style&index=0&id=2842ada6&scoped=true&lang=css"

import exportComponent from "/var/www/html/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2842ada6"],['__file',"AppLogo.vue"]])

export default __exports__